<template>
    <inertia-link class="ml-4 px-3 py-2 md:px-4 md:py-2 rounded text-sm font-medium uppercase leading-5 text-white bg-gray-500 border border-transparent active:bg-gray-600 hover:bg-gray-700 focus:outline-none focus:shadow-outline-purple whitespace-no-wrap" :href="href">
        <span>
            <slot></slot>
        </span>
    </inertia-link>
</template>

<script>
export default {
    name: "BackButton",
    props: ['routeName', 'routeParam'],
    data() {
        return {
            href: this.routeParam ? route(this.routeName, this.routeParam) : route(this.routeName)
        };
    },
}
</script>

<style scoped>

</style>
